// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3_b89","insightsList":"newBusinessInsightsMenu_insightsList__UeXNJ","active":"newBusinessInsightsMenu_active__31Nhu"};